import type { ColumnDef } from "@tanstack/vue-table";
import type { ActionButtonOption } from "../ActionButtons";
import type { FacetedFilter } from "../FacetedFilters";
import type { SelectedActionButtonOption } from "../SelectedActions";
import { computed, onMounted, onUnmounted } from "vue";
import { createEmitter } from "@/services/emitter";

export const useColumns = <T>(columns: () => ColumnDef<T>[]) => computed(columns);

export const useFilters = (filters: () => FacetedFilter[]) => computed(filters);

export const useSelectedButtons = <T>(selectedButtons: () => SelectedActionButtonOption<T>[]) =>
  computed(selectedButtons);

export const useButtons = (buttons: () => ActionButtonOption[]) => computed(buttons);

export interface SetFilterEvent {
  id: string;
  column: string;
  setter: (payload: { operator?: string; value: any }) => {
    operator?: string;
    value: any;
  };
}

type TableEmitterEventMap = {
  "set-filter": [SetFilterEvent];
};

export const tableEmitter = createEmitter<TableEmitterEventMap>();

export const useTableEmitter = <K extends keyof TableEmitterEventMap>(
  event: K,
  handler: (...args: TableEmitterEventMap[K]) => void
) => {
  onMounted(() => {
    tableEmitter.on(event, handler);
  });

  onUnmounted(() => {
    tableEmitter.off(event);
  });
};
